import { useCallback, useRef, useState } from 'react';

const useInputInsertion = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const insertionHandlerRef = useRef<Nullable<(...args: any[]) => void>>(null);
    const [insertionOptions, setInsertionOptions] = useState({
        hintText: '',
        focusedInputKey: '',
        inputFilterKey: '',
        channel: '',
    });

    const updateInsertionHandler = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (inputKey: string, insertionHandler: (...args: any[]) => void) => {
            if (inputKey === insertionOptions.focusedInputKey) {
                insertionHandlerRef.current = insertionHandler;
            }
        },
        [insertionOptions.focusedInputKey],
    );

    return {
        insertionHandler: (...args) => insertionHandlerRef.current?.(...args),
        updateInsertionHandler,
        insertionOptions,
        setInsertionOptions,
    };
};

export default useInputInsertion;
